import { Picture } from "./Picture.js";

/**
 * Class to implement the picture manager
 * as a singleton, which can be instantiated by
 * any other extension as a dependency
 */
export class PictureManager {
    private static manager: PictureManager;
    private instances: Picture[] = [];

    /**
     * The private constructor
     * prevents direct instantiation
     */
    private constructor() {
        this.instances = [...this.pictures].map((picture) => {
            return new Picture(picture);
        });
    }

    /**
     * Method to instantiate all
     * pictures on the current page
     *
     * @param {boolean} [reset=false]
     * @returns {PictureManager}
     */
    public static use(reset: boolean = false): PictureManager {
        if (!PictureManager.manager || reset) {
            PictureManager.manager = new PictureManager();
        }
        return PictureManager.manager;
    }

    /**
     * Selects the pictures
     *
     * @returns {NodeListOf<HTMLPictureElement>}
     */
    protected get pictures(): NodeListOf<HTMLPictureElement> {
        return document.querySelectorAll(`picture`);
    }

    /**
     * Returns the number of instantiated pictures
     *
     * @returns {number}
     */
    public get length(): number {
        return this.instances.length;
    }
}
